module.exports = __WEBPACK_EXTERNAL_MODULE_256__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Pikaday","commonjs2":"pikaday","commonjs":"pikaday","amd":"pikaday"}
// module id = 256
// module chunks = 0